<template>
  <v-container
    fluid
    class="py-0"
  >
    <top-bar
      :header="loading ? '' : `FAQ: ${(faq && faq.question) || ''}`"
    />
    <v-row>
      <v-col
        cols="12"
        md="9"
      >
        <v-progress-circular
          v-if="loading"
          indeterminate
        />
        <div
          v-else
          v-html="(faq && faq.answer) || ''"
        />
      </v-col>
      <v-col
        cols="12"
        md="3"
      >
        <account-manager />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Faq } from '@/models'

export default {
  name: 'Faq',
  data () {
    return {
      loading: false
    }
  },
  computed: {
    faq () {
      return Faq.find(this.$route.params.faqId)
    }
  },
  async created () {
    if (!this.faq) {
      await this.loadFaq()
    }
    if (!this.faq) {
      this.$router.push({ path: '/notfound' })
    }
  },
  async beforeRouteUpdate (to, from, next) {
    this.loading = true
    await Faq.fetchOne(to.params.faqId)
    this.loading = false
    next()
  },
  methods: {
    async loadFaq () {
      if (this.$route.params.faqId) {
        this.loading = true
        try {
          await Faq.fetchOne(this.$route.params.faqId)
          this.loading = false
        } catch (e) {
          this.loading = false
          throw e
        }
      }
    }
  }
}
</script>
